<template>
  <div>
    <div v-show="check_status==='checking'">
      <b-tabs v-model="fun_index" fill>
        <b-tab key="use_by_input" title="輸入票號核銷">
          <div class="simple-center">
            <!--<h3>輸入票號核銷</h3><br>
            <span>說明：為保護消費者權益,輸入票號核銷需要消費者提供驗證碼,驗證碼會發送至消費者票夾的重要訊息,輸入正確方可核銷<br>(line酷券請輸入16碼票號,酷券無驗證碼即可進入確認票券資訊進行核銷)</span><br>
            <input class="col-md-4 the-input mt-1" ref="ticket_no" type="email" style="text-transform: uppercase;" :disabled="input_status==='sent'" v-model="ticket_no" @keyup.enter="sendVerifyMsg" placeholder="輸入票夾看到的AA票號或16碼酷券票號"/>
            <b-button class="col-md-2 mt-1 ml-1" @click.stop="sendVerifyMsg">{{input_status==='initial'?'發送驗證碼':'重輸票號/重送'}}</b-button><br>
            <br>
            <input class="col-md-4 the-input mt-1" ref="m_seq_no" type="tel" :disabled="input_status!=='sent'" v-model="manual_seq_no" @keyup.enter="confirmSeq" placeholder="輸入驗證碼(若逾時請重新送出)"/>
            <b-button class="col-md-2 mt-1 ml-1" :disabled="input_status!=='sent'" @click.stop="confirmSeq">輸入驗證碼</b-button><br>
          </div>-->
          <h3>手動輸入核銷</h3><br>
            <span>(核銷驗證碼時效只有10分鐘且只能被輸入/掃描一次,如失效請客人刷新一下畫面)</span><br>
            <span>(web核銷不再支援原輸入票號再發送驗證碼的複雜操作方式)</span><br>
            <input class="col-md-4 the-input mt-1" ref="ticket_use_seq" type="tel" v-model="ticket_use_seq" @keyup.enter="confirmSeq('use_seq')" placeholder="QRCODE電子票券請於此輸入顯示之驗證碼,共8碼序號"/>
            <b-button class="col-md-2 mt-1 ml-1" @click.stop="confirmSeq('use_seq')">輸入驗證碼使用</b-button><br>
            <br>
            <input class="col-md-4 the-input mt-1" ref="line_ticket_no" type="tel" v-model="line_ticket_no" @keyup.enter="confirmSeq('line_code')" placeholder="Line酷券或3T票請於此輸入16碼序號"/>
            <b-button class="col-md-2 mt-1 ml-1" @click.stop="confirmSeq('line_code')">Line酷券或3T票序號使用</b-button><br>
          </div>
        </b-tab>
        <b-tab key="use_by_scan" :title="'QRCode核銷('+(supportScan?'Ｏ':'X')+')'" @click.prevent="turnCameraOn(false)" :disabled="!supportScan">
          <div class="my-2">
            <span>Line酷券請輸入序號核銷</span><b-button @click="go_line_input">使用酷券</b-button>
          </div>
          <qrcode-stream style="width:90vw;height:45vh;" :camera="camera" @decode="onDecode" @init="onInit"></qrcode-stream>
        </b-tab>
      </b-tabs>
    </div>

    <div v-show="check_status==='confirmed'" >
      <b-button @click.stop="backEnter" style="float:left;margin:5px;">返回</b-button>
      <h3 style="text-align:left;padding-top:5px;">核銷使用票券資訊</h3><br>
      <b-card
        style="margin-top:-10px;"
        title="票券狀態"
      >
        <b-card-text>{{ticket_info.warn_info?ticket_info.warn_info.notcie_msg:''}}</b-card-text>
      </b-card>
      <div style="display:block;"></div><br>
      <span style="float:left;margin-top:-15px;margin-left:25%;">刷卡時間：</span><br>
      <span style="float:left;margin-left:25%;">票號：{{ticket_info.ticket_no ? ticket_info.ticket_no :ticket_info.tkid}}</span><br>
      <hr/>
      <span style="float:left;margin-top:-15px;margin-left:25%;">體驗者：{{ticket_info.use_user_name?ticket_info.use_user_name:'酷券使用者'}}</span><br>
      <span style="float:left;margin-left:25%;">預約時間：(尚未開放)</span><br>
      <span style="float:left;margin-left:25%;">預約店家：(尚未開放)</span><br>
      <b-button @click.stop="backEnter">不使用</b-button>
      <b-button class="ml-3" style="background-color:deeppink;" @click.stop="confirmUse">使用票券</b-button>
    </div>
  </div>
</template>

<script>

import { QrcodeStream } from 'vue-qrcode-reader'

import {
  apiCheckTicketNo,
  apiConfirmAttendance,
  apiManualInputTicketNo
} from '@/api/WorkSite.js'

export default {
  name: 'StoreServiceExecution',
  components: {
    QrcodeStream,
  },
  data: function () {
    return {
      liff_url: 'https://line.me/R/app/' + process.env.VUE_APP_LIFF_QUICK_SCAN + '?scan_no=',
      ticket_no:"",
      manual_seq_no:"",
      ticket_use_seq:"",
      line_ticket_no:"",
      input_status:"initial",//initial=>sent
      check_status:"checking",//checking=>confirmed
      ticket_info:{},
      camera: 'auto',
      supportScan:false,
      inChecking: false,
      fun_index:0,
    }
  },
  methods: {
    reopen() {
      //this.$bus.fnShowInfo('哭哭...Line內建瀏覽器不能使用掃描😭幫您自動從外部重新打開以使用核銷功能唷！')
      this.$bus.fnShowInfo('自動轉換中~請稍等😊')
      let line_login_append_param_str = ''
      if (this.$bus.line_token && this.$bus.line_uid) {
        line_login_append_param_str = '&accessToken='+this.$bus.line_token+'&userId='+this.$bus.line_uid
      }
      setTimeout(() => {
        window.location.href = window.location.href+"?openExternalBrowser=1&landing=StoreServiceExecution"+line_login_append_param_str
      }, 2000);
    },
    onInit (promise) {
      promise.then(
        response=> {
          // eslint-disable-next-line
          console.log(response)
          if (this.inChecking) {
            return
          }
          this.turnCameraOn(true)
        }, 
        error => {
          this.notSupportScan(error)
        }
      )
    },
    notSupportScan(reason) {
      // eslint-disable-next-line
      console.log(reason)
      this.supportScan = false
      if (this.fun_index !== 0) {
        this.fun_index = 0
      }
    },
    async onDecode (content) {
      console.log('here', content)
      this.turnCameraOff()
      if (!content) {
        this.turnCameraOn()
      }
      else {
        if (this.inChecking) {
          return
        }
        // 用後台掃的話取代line網址
        content = content.replace(this.liff_url, '')
        console.log('here2', content)
        console.log('here3', this.liff_url)
        // 呼叫api
        let Param = {
          module:'work_site',
          method:'checkTicketNo',
          ticket_checkno:content,
          ticket_no:'',
          ticket_manual_checkno:''
        }
        this.inChecking = true
        let vm = this
        apiCheckTicketNo(Param).then(function(resp){
          let data = resp.data
          //成功就跳下去
          vm.turnCameraOff()
          vm.$bus.fnShowInfo("掃描成功")
          vm.ticket_info = data.data.ticket_data
          vm.inChecking = false
          setTimeout(() => {
            vm.turnCameraOff()
            vm.$bus.fnClosePopup()
            vm.ticket_no = ""
            vm.check_status = "confirmed"
          }, 1500);
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            vm.turnCameraOff()
            setTimeout(() => {
              vm.turnCameraOn()
              vm.inChecking = false
            }, 1000);
            return
          }
        })

        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnShowInfo(data.msg)
        //     vm.turnCameraOff()
        //     setTimeout(() => {
        //       vm.turnCameraOn()
        //       vm.inChecking = false
        //     }, 1000);
        //     return
        //   }
        //   //成功就跳下去
        //   vm.turnCameraOff()
        //   vm.$bus.fnShowInfo("掃描成功")
        //   vm.ticket_info = data.data.ticket_data
        //   vm.inChecking = false
        //   setTimeout(() => {
        //     vm.turnCameraOff()
        //     vm.$bus.fnClosePopup()
        //     vm.ticket_no = ""
        //     vm.check_status = "confirmed"
        //   }, 1500);
        // }, this)
      }
    },
    turnCameraOn (reset = false) {
      if (reset) {
        this.inChecking = false
        this.supportScan = true
        if (this.fun_index === 0) {
          setTimeout(() => {
            //能不能跳到第二個tab看看呢？
            this.fun_index = 1
          }, 1000);
        }
      }
      if (this.camera !== 'auto') {
        this.camera = 'auto'
      }
    },
    turnCameraOff () {
      this.camera = 'off'
    },
    confirmUse() {
      let Param = {
        module:'work_site',
        method:'confirmAttendance',
        ticket_checkno:this.ticket_info.ticket_check_no,
        ticket_no:this.ticket_info.ticket_no,
        ticket_do_item_id:this.ticket_info.do_items[0].ticket_do_item_id,
        ticket_project_service_item_id:this.ticket_info.ticket_possible_project_service_items[0].ticket_project_service_item_id,
        reservation_id:0,
        manual_confirm:1
      }
      let vm = this

      apiConfirmAttendance(Param).then(function(resp){
        let data = resp.data
        vm.$bus.landingComponent = 'ServiceExecutionList'
        vm.turnCameraOn()
        vm.$bus.fnShowInfo(vm.ticket_info.ticket_no=='LineSample'?"恭喜!Line店家開通驗證完成":"票券使用成功")
        vm.ticket_info = {}
        setTimeout(() => {
          vm.ticket_no = ""
          vm.manual_seq_no = ""
          vm.input_status = 'initial'
          vm.check_status = "checking"
        }, 2000);

      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function(data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     return
      //   }

      //   vm.$bus.landingComponent = 'ServiceExecutionList'
      //   vm.turnCameraOn()
      //   vm.$bus.fnShowInfo(vm.ticket_info.ticket_no=='LineSample'?"恭喜!Line店家開通驗證完成":"票券使用成功")
      //   vm.ticket_info = {}
      //   setTimeout(() => {
      //     vm.ticket_no = ""
      //     vm.manual_seq_no = ""
      //     vm.input_status = 'initial'
      //     vm.check_status = "checking"
      //   }, 2000);
      // }, this)
    },
    backEnter() {
      this.turnCameraOn()
      this.ticket_info = {}
      this.ticket_no = ""
      this.manual_seq_no = ""
      this.ticket_use_seq = ""
      this.line_ticket_no = ""
      setTimeout(() => {
        this.check_status = "checking"
        //this.input_status = 'initial'
      }, 100);
    },
    sendVerifyMsg() {
      if ((this.ticket_no.length !== 10 && this.ticket_no.length !== 16)) {
        this.$bus.fnShowInfo("請輸入完整10碼AA票號或16碼酷券票號")
        return
      }
      if (this.input_status==='sent') {
        this.input_status = 'initial'
        setTimeout(() => {
          this.$refs.ticket_no.focus()
        }, 200);
        return
      }
      let Param = null
      // 一般需驗證aa票號
      if (this.ticket_no.length !== 16) {
        Param = {
          module:'work_site',
          method:'manualInputTicketNo',
          ticket_no:this.ticket_no.toUpperCase()
        }

        let vm = this
        apiManualInputTicketNo(Param).then(function(resp){
          let data = resp.data
          vm.$bus.fnShowInfo("驗證碼已送出,請消費者自票夾的重要訊息內找到剛發送的驗證碼並輸入該驗證碼")
          vm.input_status = "sent"
          // 無效...?
          setTimeout(() => {
            vm.$refs.m_seq_no.focus()
          }, 1500);

        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        })

        // this.$bus.apiCall(Param, function(data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnShowInfo(data.msg)
        //     return
        //   }
        //   vm.$bus.fnShowInfo("驗證碼已送出,請消費者自票夾的重要訊息內找到剛發送的驗證碼並輸入該驗證碼")
        //   vm.input_status = "sent"
        //   // 無效...?
        //   setTimeout(() => {
        //     vm.$refs.m_seq_no.focus()
        //   }, 1500);
        // }, this)
      }
      else {
        // 酷券就當作掃描到那輸入的16碼數字即可
        Param = {
          module:'work_site',
          method:'checkTicketNo',
          ticket_checkno:this.ticket_no,
          ticket_no:'',
          ticket_manual_checkno:''
        }

        let vm = this
        apiCheckTicketNo(Param).then(function(resp){
          let data = resp.data
          vm.$bus.fnShowInfo("酷券票號驗證成功")
          vm.ticket_info = data.data.ticket_data
          setTimeout(() => {
            vm.$bus.fnClosePopup()
            vm.ticket_no = ""
            vm.check_status = "confirmed"
          }, 1500);

        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo('庫券序號輸入失敗：'+data.msg)
            return
          }
        })

        // this.$bus.apiCall(Param, function(data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnShowInfo('庫券序號輸入失敗：'+data.msg)
        //     return
        //   }
        //   vm.$bus.fnShowInfo("酷券票號驗證成功")
        //   vm.ticket_info = data.data.ticket_data
        //   setTimeout(() => {
        //     vm.$bus.fnClosePopup()
        //     vm.ticket_no = ""
        //     vm.check_status = "confirmed"
        //   }, 1500);
        // }, this)
      }
      
    },
    confirmSeq(src) {
      let manual_seq_no = this.manual_seq_no
      let check_no = ''
      if (src == 'use_seq') {
        if (this.ticket_use_seq.length == 8) {
          manual_seq_no = this.ticket_use_seq
        }
        else {
          this.$bus.fnShowInfo("請輸入8碼核銷驗證碼")
          this.$refs.ticket_use_seq.focus()
        }
      }
      else if (src == 'line_code') {
        if (this.line_ticket_no.length == 16) {
          check_no = this.line_ticket_no
        }
        else {
          this.$bus.fnShowInfo("請正確輸入16碼酷券序號")
          this.$refs.line_ticket_no.focus()
        }
      }
      else {
        //不會用到的舊情境,送出票號後才可以輸入用戶收到的驗證碼,再輸入一次才確認使用
        //現在流程都換掉沒有第一步就直接進入使用了
        /*
        if (this.manual_seq_no.length !== 5) {
          if (this.input_status === 'sent') {
            this.$bus.fnShowInfo("請輸入驗證碼")
            this.$refs.m_seq_no.focus()
          }
          else {
            this.$bus.fnShowInfo("請先輸入票號")
            this.$refs.ticket_no.focus()
          }
          return
        }*/
      }
      
      let Param = {
        module:'work_site',
        method:'checkTicketNo',
        ticket_checkno:check_no,
        ticket_no:this.ticket_no,
        ticket_manual_checkno:manual_seq_no
      }

      if (src === 'use_seq') {
        Param['ticket_manual_checkno'] = ''
        Param['ticket_checkno'] = 'SPA99_' + this.ticket_use_seq
      }

      let vm = this
      apiCheckTicketNo(Param).then(function(resp){
        let data = resp.data
        vm.$bus.fnShowInfo("驗證成功")
        vm.ticket_info = data.data.ticket_data
        setTimeout(() => {
          vm.$bus.fnClosePopup()
          vm.ticket_no = ""
          vm.check_status = "confirmed"
        }, 1500);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function(data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     return
      //   }
      //   vm.$bus.fnShowInfo("驗證成功")
      //   vm.ticket_info = data.data.ticket_data
      //   setTimeout(() => {
      //     vm.$bus.fnClosePopup()
      //     vm.ticket_no = ""
      //     vm.check_status = "confirmed"
      //   }, 1500);
      // }, this)
    },
    go_line_input() {
      this.line_ticket_no = ''
      this.fun_index = 0
      setTimeout(() => {
        this.$refs.line_ticket_no.focus()
      }, 100);
    }
  },
  computed:{
    
  },
  created () {
    
  },
  mounted () {
    // iphone/iPad不跳，因為Line裡面可以開相機，但安卓不行
    if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1){
      return
    }
    // 只剩非iOS的又是在Line裡面的話就跳外部瀏覽器
    if (navigator.userAgent.indexOf('Line') > -1) {
      this.reopen()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.simple-center {
  display:table-cell;
  width:100vw;
  height:65vh;
  vertical-align: middle;
}
.the-input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>
